export const getRejectedReducer = (state, action) => {
  state.error = action.payload;
};

export const getLanguagesFulfilledReducer = (state, action) => {
  state.languages = action.payload;
};
